import { idealButlerTraits } from '@/mocks/philosophyData';
import { useTranslation } from 'react-i18next';

export default function IdealButler() {
  const { t } = useTranslation();
  const traitKeys = [
    { title: 'philosophy.ideal.1.title', desc: 'philosophy.ideal.1.desc', icon: idealButlerTraits[0].icon },
    { title: 'philosophy.ideal.2.title', desc: 'philosophy.ideal.2.desc', icon: idealButlerTraits[1].icon },
    { title: 'philosophy.ideal.3.title', desc: 'philosophy.ideal.3.desc', icon: idealButlerTraits[2].icon },
    { title: 'philosophy.ideal.4.title', desc: 'philosophy.ideal.4.desc', icon: idealButlerTraits[3].icon },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            OUR VISION
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('philosophy.ideal.title')}
          </h2>
          {String(t('philosophy.ideal.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('philosophy.ideal.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {traitKeys.map((trait, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 p-6 flex items-start gap-5 cursor-default"
            >
              <div className="w-11 h-11 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                <i className={`${trait.icon} text-accent-500 text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-2">
                  {t(trait.title)}
                </h3>
                {String(t(trait.desc)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
